// Resultat de pesee d'une facture de la borne (FirewoodInvoiceView) : un petit
// cartouche aligne a droite sous la ligne Total du tableau, libelle a gauche,
// tonnage en gras a droite (Chady 2026-10-12 : l'ancien bandeau gris centre,
// « Weighing result : 1.60 tons », plus court que le tableau, recouvrait en
// plus le renvoi photos « * ... »).
//
// Polices : libelle en Amiri (diacritiques ro/fr/de), chiffre en Helvetica
// gras comme les montants de la ligne Total. Rend la main en Amiri normal.

const LABELS = {
  fr: "Résultat de la pesée",
  nl: "Weegresultaat",
  de: "Wiegeergebnis",
  es: "Resultado del pesaje",
  en: "Weighing result",
  ro: "Rezultat cântărire",
};

const LOCALES = { fr: "fr-FR", nl: "nl-NL", de: "de-DE", es: "es-ES", en: "en-GB", ro: "ro-RO" };

const ACCENT = [26, 188, 156]; // en-tete du tableau (theme « grid » d'autotable)
const FILL = [236, 248, 244];
const WIDTH = 56; // colonnes Unit price -> Total TTC
const HEIGHT = 6;

/** Tonnage de la borne : TotalTonnage, sinon somme des produits ; null si inconnu. */
export function kioskTonnage(parsed) {
  if (!parsed) return null;
  let t = parsed.totals ? parseFloat(String(parsed.totals.totalTonnage || "").replace(",", ".")) : NaN;
  if (!(t > 0) && Array.isArray(parsed.products)) {
    t = parsed.products.reduce((sum, p) => sum + (parseFloat(String(p.tonnage || "").replace(",", ".")) || 0), 0);
  }
  return t > 0 ? t : null;
}

/** « 1,60 t » (virgule decimale sauf en anglais). */
export function formatTonnes(tonnes, lang) {
  const locale = LOCALES[lang] || LOCALES.en;
  return Number(tonnes).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " t";
}

/**
 * Dessine le cartouche ; `right` = bord droit du tableau, `top` = haut du cadre.
 * Rend la taille de police trouvee en entrant.
 */
export function drawWeighingResult(doc, right, top, tonnes, lang) {
  const previousSize = doc.getFontSize();
  const x = right - WIDTH;
  const baseline = top + HEIGHT / 2 + 1.1;

  doc.setFillColor(...FILL);
  doc.rect(x, top, WIDTH, HEIGHT, "F");
  doc.setFillColor(...ACCENT);
  doc.rect(x, top, 0.8, HEIGHT, "F");

  doc.setFont("Amiri", "normal");
  doc.setFontSize(8);
  doc.setTextColor(85, 85, 85);
  doc.text(x + 3, baseline, LABELS[lang] || LABELS.en);

  const value = formatTonnes(tonnes, lang);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(30, 30, 30);
  doc.text(right - 2.5 - doc.getTextWidth(value), baseline, value);

  doc.setFont("Amiri", "normal");
  doc.setFontSize(previousSize);
  doc.setTextColor(0, 0, 0);
}
